import { createRequiredContext } from '../create-required-context';
import type { ApiClient } from './api-client';

export const [ApiClientContext, useApiClient] =
  createRequiredContext<ApiClient>('ApiClientContext');
